import DataTablePagination from "./DataTablePagination";
import FillEmpty from "./FillEmpty";

console.log("module loaded");
export default angular
.module("energis.datatable", [])
.directive("pagination", DataTablePagination)
.directive("fillEmpty", FillEmpty)
.name


// WEBPACK FOOTER //
// ./src/DataTable/index.js